module.exports = __webpack_public_path__ + "img/laboratory.d47c43c3.svg";